import React from 'react';
import { useSelector } from 'src/client/redux';
import CamsSlider from '../Cams/CamsSlider/CamsSlider';

const sliderSettings = {
  autoplay: false,
  draggable: true,
  responsive: [
    { breakpoint: 986, settings: { slidesToShow: 4, slidesToScroll: 4 } },
    { breakpoint: 1200, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 100000, settings: { slidesToShow: 6, slidesToScroll: 6 } },
  ],
};

export const MovieCams = () => {
  const { config } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);

  const { hasCamsSlider } = config;

  if (!user || !hasCamsSlider) {
    return null;
  }

  return <CamsSlider camTrackingPosition="slider" settings={sliderSettings} />;
};
